export default __webpack_public_path__ + "static/media/Thaumaturge's Boots of the Emperor's Favor.01b8473b.jpg";